import { useState, useEffect, useCallback } from 'react';

export function useWidth(elementRef) {
	const [width, setWidth] = useState(null);

	const updateWidth = useCallback(() => {
		if (elementRef && elementRef.current) {
			setWidth(elementRef.current.getBoundingClientRect().width);
		}
	}, [elementRef]);

	useEffect(() => {
		updateWidth();
		window.addEventListener('resize', updateWidth);
		return () => {
			window.removeEventListener('resize', updateWidth);
		};
	}, [updateWidth]);

	return [width];
}
